import { useTranslation } from 'react-i18next';

/**
 * Ось записи (спека §2): archived_at. Независима от состояния файла —
 * архивная запись с целым файлом это норма.
 */
export function ArchivedChip({ archivedAt }: { archivedAt: string | null }) {
  const { t } = useTranslation();
  if (!archivedAt) return null;
  return <span className="chip arch">{t('archive.chip.archived')}</span>;
}
